import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { registerLocaleData } from '@angular/common';
import localeMx from '@angular/common/locales/es-MX';

import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Material
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';

// Components
import { MainComponent } from 'src/componets/main/main.component';
import { FooterComponent } from 'src/componets/footer/footer.component';

// Screens
import { HomeComponent } from 'src/screens/home/home.component';
import { UserFormComponent } from 'src/screens/user-form/user-form.component';
import { QuestionnaireComponent } from 'src/screens/questionnaire/questionnaire.component';
import { ResultsComponent, DownloadDialog } from 'src/screens/results/results.component';
import { environment } from 'src/environments/environment';

registerLocaleData(localeMx);

@NgModule({
	declarations: [
		AppComponent,
		MainComponent,
		UserFormComponent,
		QuestionnaireComponent,
		ResultsComponent,
		HomeComponent,
		FooterComponent,
		DownloadDialog
	],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
		ReactiveFormsModule,
		FormsModule,
        FlexLayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
        MatStepperModule,
        MatSliderModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
		MatRadioModule,
		MatDialogModule
    ],
	providers: [{ provide: LOCALE_ID, useValue: 'es-Mx'}],
	bootstrap: [AppComponent],
})
export class AppModule {}
